import { useMemo } from "react";

import { useSelector } from "react-redux";

import {
    selectIntentSignalSelectedTopics,
    selectIntentSignalSelectedTopicsCreatedAt,
} from "app/pages/sales-intelligence/sub-modules/intent/store/signal/selectors/selectors";
import { useUISignalsGroupedByType } from "app/pages/sales-intelligence/sub-modules/signals/hooks/useUISignals";
import type ISignalsListViewModel from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalsListViewModel";
import createSignalsListViewModel from "app/pages/sales-intelligence/sub-modules/signals/services/signals-list-view-model/factory";

export const useSignalsListViewModel = (): ISignalsListViewModel => {
    const intentTopics = useSelector(selectIntentSignalSelectedTopics);
    const intentTopicCreatedAt = useSelector(selectIntentSignalSelectedTopicsCreatedAt);

    const uiSignalsGroupedByType = useUISignalsGroupedByType();

    return useMemo(
        () =>
            createSignalsListViewModel({
                uiSignalsGroupedByType,
                intentTopics,
                intentTopicCreatedAt,
            }),
        [uiSignalsGroupedByType, intentTopics, intentTopicCreatedAt],
    );
};
